import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

import { ConnectCoreModule, ConnectCoreModuleConfig } from '@aveva/connect-web-core';
import { TrainingModule } from './training/training.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { ApplicationInsightsService } from './services/application-insights.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { TelemetryInterceptor } from './interceptors/telemetry.interceptor';


export function initializeApp(aiService: ApplicationInsightsService) {
  return () => aiService.init();
}

const coreModuleConfig: ConnectCoreModuleConfig = {
  authentication: {
    authority: environment.authority,
    clientId: environment.clientId,
    cachePrefix: 'Training_Web',
    singleSignOutUrl: environment.singleSignOutUrl
  },
  authorization: {
    cachePrefix: 'Training_Web'
  },
  connectApi: {
    registry: environment.apis.registry,
    am: environment.apis.am,
    scm: environment.apis.scm,
    uam: environment.apis.uam,
    assets: environment.apis.assets
  },
  components: {
    appHeaderTitle: 'Connect',
    termsAndConditions: 'https://sw.aveva.com/legal',
    connectLink: environment.connect
  }
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ConnectCoreModule.forRoot(coreModuleConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TrainingModule,
    AppRoutingModule,
    MatProgressSpinnerModule,
    MatMomentDateModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ApplicationInsightsService],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    { provide : HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TelemetryInterceptor,
      multi: true
    },
    { provide : LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
